export default __webpack_public_path__ + "static/media/info.23e92631.png";